import { resolveIdentifier, types } from 'mobx-state-tree';
import { PharmacyNeighbor } from './PharmacyNeighbor';
import { Pharmacy } from './Pharmacy';
import { Protection } from './Protection';
import { Duty } from './Duty';
import { Municipality } from './Municipality';
import { TransferRequest } from './TransferRequest';

export const PharmacyDetails = types.compose(
  Pharmacy,
  types
    .model('PharmacyDetails', {
      phone: types.maybe(types.string),
      address: types.maybe(types.string),
      zipCode: types.maybe(types.string),
      city: types.maybe(types.string),
      municipalityId: types.maybe(types.integer),
      municipality: types.maybe(Municipality),
      group: types.maybe(types.string),
      language: types.string,
      latitude: types.maybe(types.number),
      level: types.maybe(types.integer),
      longitude: types.maybe(types.number),
      zoneId: types.maybe(types.integer),
      receivesSms: types.maybe(types.boolean),
      isContributing: types.boolean,
      isActive: types.maybe(types.boolean),
      density: types.maybe(types.integer),
      minDistance: types.maybe(types.integer),
      maxDistance: types.maybe(types.integer),
      minDistance2: types.maybe(types.integer),
      maxDistance2: types.maybe(types.integer),
      userId: types.maybe(types.integer),
      pharmacyNeighbors: types.optional(types.array(PharmacyNeighbor), []),
      protections: types.optional(types.array(Protection), []),
      // transferRequestToApbNumberNavigations: types.optional(types.array(TransferRequest), []),
      anchor: types.maybe(types.string),
      distance: types.maybe(types.number),
      prefDutyDayOn: types.maybe(types.string),
      prefDutyDayOff: types.maybe(types.string),
      x: types.maybe(types.number),
      y: types.maybe(types.number),
    })
    .views((self) => ({
      neighbors: () => {
        return self.pharmacyNeighbors.map((n) => resolveIdentifier(Pharmacy, self, n.neighborId));
      },
    })),
);
